/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRaifragenGet$Json } from '../fn/raifragen/api-raifragen-get-json';
import { ApiRaifragenGet$Json$Params } from '../fn/raifragen/api-raifragen-get-json';
import { apiRaifragenGet$Plain } from '../fn/raifragen/api-raifragen-get-plain';
import { ApiRaifragenGet$Plain$Params } from '../fn/raifragen/api-raifragen-get-plain';
import { apiRaifragenIdDelete } from '../fn/raifragen/api-raifragen-id-delete';
import { ApiRaifragenIdDelete$Params } from '../fn/raifragen/api-raifragen-id-delete';
import { apiRaifragenIdGet$Json } from '../fn/raifragen/api-raifragen-id-get-json';
import { ApiRaifragenIdGet$Json$Params } from '../fn/raifragen/api-raifragen-id-get-json';
import { apiRaifragenIdGet$Plain } from '../fn/raifragen/api-raifragen-id-get-plain';
import { ApiRaifragenIdGet$Plain$Params } from '../fn/raifragen/api-raifragen-id-get-plain';
import { apiRaifragenIdPut } from '../fn/raifragen/api-raifragen-id-put';
import { ApiRaifragenIdPut$Params } from '../fn/raifragen/api-raifragen-id-put';
import { apiRaifragenPost$Json } from '../fn/raifragen/api-raifragen-post-json';
import { ApiRaifragenPost$Json$Params } from '../fn/raifragen/api-raifragen-post-json';
import { apiRaifragenPost$Plain } from '../fn/raifragen/api-raifragen-post-plain';
import { ApiRaifragenPost$Plain$Params } from '../fn/raifragen/api-raifragen-post-plain';
import { Raifragen } from '../models/raifragen';

@Injectable({ providedIn: 'root' })
export class RaifragenService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRaifragenGet()` */
  static readonly ApiRaifragenGetPath = '/api/Raifragen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRaifragenGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaifragenGet$Plain$Response(params?: ApiRaifragenGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Raifragen>>> {
    return apiRaifragenGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRaifragenGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaifragenGet$Plain(params?: ApiRaifragenGet$Plain$Params, context?: HttpContext): Observable<Array<Raifragen>> {
    return this.apiRaifragenGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Raifragen>>): Array<Raifragen> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRaifragenGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaifragenGet$Json$Response(params?: ApiRaifragenGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Raifragen>>> {
    return apiRaifragenGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRaifragenGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaifragenGet$Json(params?: ApiRaifragenGet$Json$Params, context?: HttpContext): Observable<Array<Raifragen>> {
    return this.apiRaifragenGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Raifragen>>): Array<Raifragen> => r.body)
    );
  }

  /** Path part for operation `apiRaifragenPost()` */
  static readonly ApiRaifragenPostPath = '/api/Raifragen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRaifragenPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRaifragenPost$Plain$Response(params?: ApiRaifragenPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Raifragen>> {
    return apiRaifragenPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRaifragenPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRaifragenPost$Plain(params?: ApiRaifragenPost$Plain$Params, context?: HttpContext): Observable<Raifragen> {
    return this.apiRaifragenPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Raifragen>): Raifragen => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRaifragenPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRaifragenPost$Json$Response(params?: ApiRaifragenPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Raifragen>> {
    return apiRaifragenPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRaifragenPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRaifragenPost$Json(params?: ApiRaifragenPost$Json$Params, context?: HttpContext): Observable<Raifragen> {
    return this.apiRaifragenPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Raifragen>): Raifragen => r.body)
    );
  }

  /** Path part for operation `apiRaifragenIdGet()` */
  static readonly ApiRaifragenIdGetPath = '/api/Raifragen/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRaifragenIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaifragenIdGet$Plain$Response(params: ApiRaifragenIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Raifragen>> {
    return apiRaifragenIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRaifragenIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaifragenIdGet$Plain(params: ApiRaifragenIdGet$Plain$Params, context?: HttpContext): Observable<Raifragen> {
    return this.apiRaifragenIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Raifragen>): Raifragen => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRaifragenIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaifragenIdGet$Json$Response(params: ApiRaifragenIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Raifragen>> {
    return apiRaifragenIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRaifragenIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaifragenIdGet$Json(params: ApiRaifragenIdGet$Json$Params, context?: HttpContext): Observable<Raifragen> {
    return this.apiRaifragenIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Raifragen>): Raifragen => r.body)
    );
  }

  /** Path part for operation `apiRaifragenIdPut()` */
  static readonly ApiRaifragenIdPutPath = '/api/Raifragen/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRaifragenIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRaifragenIdPut$Response(params: ApiRaifragenIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiRaifragenIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRaifragenIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRaifragenIdPut(params: ApiRaifragenIdPut$Params, context?: HttpContext): Observable<void> {
    return this.apiRaifragenIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiRaifragenIdDelete()` */
  static readonly ApiRaifragenIdDeletePath = '/api/Raifragen/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRaifragenIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaifragenIdDelete$Response(params: ApiRaifragenIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiRaifragenIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRaifragenIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRaifragenIdDelete(params: ApiRaifragenIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiRaifragenIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
